const awsRumActionTypes = {
    CLICK: 'CLICK',
    SWIPE: 'SWIPE',
    RECEIVED: 'RECEIVED',
    WIFI_CONFIGURATION: 'WIFI_CONFIGURATION',
    CONNECTION: 'CONNECTION',
    PAIRING: 'PAIRING',
    REGISTRATION: 'REGISTRATION',
    HIDDEN: 'HIDDEN',
    VISIBLE: 'VISIBLE',
    SELECT: 'SELECT',
    SLIDE: 'SLIDE',
    NAVIGATE: 'NAVIGATE',
    COPY: 'COPY',
    CHANGED_TO: 'CHANGED_TO',
    REDEEM: 'REDEEM',
    REDEMPTION: 'REDEMPTION',
    SUBSCRIBE: 'SUBSCRIBE',
    MILESTONE: 'MILESTONE',
    CREATED: 'CREATED',
    STORE: 'STORE',
    VIEW: 'VIEW',
    SEND: 'SEND',
    ERROR: 'ERROR',
};

export default awsRumActionTypes;
